module.exports = __webpack_public_path__ + "img/aeroland-digital-store-product-05-570x470.7ab38ebf.jpg";